<template>

    <v-container v-observe-visibility="visibilityChanged">

        <!--DELETE - Dialog-->
        <v-dialog
                persistent
                v-model="deleteDialog" max-width="400px">
            <v-card>
                <v-card-title>
                    <span class="headline">Delete Position</span>
                </v-card-title>

                <v-card-text>
                    <v-form ref="deleteForm" v-model="deleteFormValidation" lazy-validation>
                        <v-checkbox
                                :rules="[v => !!v || 'You have to check this to continue!']"
                                required
                                v-model="deleteChecked" color="primary"
                                label="Do you really want to delete this position?"></v-checkbox>
                    </v-form>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary darken-1" flat @click.native="cancelDeleteDialog()">CANCEL</v-btn>
                    <v-btn color="primary darken-1" flat @click.native="deletePosition()">
                        OK
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!--Creating Invoice - Loading-->
        <v-dialog class="loading-dialog"
                  v-model="creatingInvoice"
                  persistent
                  overlay
                  max-width="450px">
            <v-card>
                <v-layout row pt-4 pb-4 pr-4 pl-4>
                    <v-flex grow>
                        <v-card-title class="headline">Creating Invoice...</v-card-title>
                    </v-flex>
                    <v-flex shrink>
                        <v-progress-circular
                                :size="70"
                                :width="7"
                                color="primary"
                                indeterminate
                        ></v-progress-circular>
                    </v-flex>
                </v-layout>
            </v-card>
        </v-dialog>

        <v-layout row wrap>

            <v-flex xs12 sm12 mb-2>

                <v-btn class="secondary white--text" @click.stop="openDialog(null)">
                    New Colli
                    <v-icon class="white--text" right>add</v-icon>
                </v-btn>

            </v-flex>

        </v-layout>

        <v-layout row wrap>

            <v-flex xs12 sm12>
                <v-layout row>
                    <v-flex xs12>
                        <v-card>
                            <v-card-title>
                                <v-layout row wrap>
                                    <v-flex xs12 md8>
                                        Pickings
                                    </v-flex>
                                    <v-flex xs12 md4>
                                        <v-text-field
                                                v-model="search"
                                                append-icon="search"
                                                label="Search"
                                                single-line
                                                hide-details
                                                clearable
                                        ></v-text-field>
                                    </v-flex>
                                </v-layout>
                            </v-card-title>

                            <v-data-table
                                    :headers="headers"
                                    :items="getItems"
                                    :pagination.sync="pagination"
                                    :total-items=total
                                    class="elevation-0"
                                    :loading="loading"
                                    :rows-per-page-items="rowsPageItems"
                            >

                                <template slot="headerCell" slot-scope="props">
                                    <v-tooltip bottom>
                                        <span slot="activator">
                                          {{ props.header.text }}
                                        </span>
                                        <span>
                                          {{ props.header.text }}
                                        </span>
                                    </v-tooltip>
                                </template>
                                <template slot="items" slot-scope="props">
                                    <v-touch tag="tr"
                                             @doubletap="openDialog(props.item.id)"
                                             @dblclick="openDialog(props.item.id)">
                                        <td>{{ props.item.id }}</td>
                                        <td class="text-xs-left">{{ props.item.colli_number }}</td>
                                        <td class="text-xs-left">{{ props.item.package_types.name }}</td>
                                        <td class="text-xs-left">{{ props.item.length }}</td>
                                        <td class="text-xs-left">{{ props.item.width }}</td>
                                        <td class="text-xs-left">{{ props.item.height }}</td>
                                        <td class="text-xs-left">{{ props.item.gross_weight }}</td>
                                        <td class="text-xs-left"> {{ props.item.created_at | toDateTimeLocalTime }}</td>
                                        <td class="text-xs-left"> {{ props.item.picking_status.name }}</td>
                                        <td class="text-xs-right">
                                            <v-icon color="red"
                                                    class="ma-1"
                                                    @click="deletePositionDialog(props.item)"
                                            >
                                                delete
                                            </v-icon>
                                        </td>


                                    </v-touch>

                                </template>
                            </v-data-table>
                        </v-card>
                    </v-flex>

                </v-layout>

                <addPickingDialog :activeTab="getActiveTab"></addPickingDialog>

            </v-flex>
        </v-layout>

        <v-layout row wrap mt-4>
            <v-flex grow>
            </v-flex>
            <v-flex shrink pr-4>
                <v-checkbox
                        v-model="hideHSCode" color="secondary"
                        label="Hide HSCode "></v-checkbox>
            </v-flex>
            <v-flex shrink>
                <v-btn shrink :loading="creatingInvoice" class="secondary white--text"
                       @click.native="createInvoice()">
                    CREATE INVOICE
                </v-btn>
            </v-flex>
        </v-layout>

    </v-container>

</template>

<script>
import {
  Settings,
  Invoice,
  Picking
} from '../../../store/namespace-helper'
import addPickingDialog from '../Pickings/AddPickingDialog.vue'
import _ from 'lodash'

import {dateFunctionFilters} from '../../../mixins/dateFunctionFilters'

export default {
  name: 'Pickings',
  components: {
    addPickingDialog
  },
  mixins: [dateFunctionFilters],
  props: {
    /*        procurementId: {
                      type: Number,
                      default: null
                    } */
  },
  data () {
    return {
      isVisible: false,
      pagination: {'sortBy': 'id', 'descending': true},
      search: '',
      total: 0,
      onDismissed: false,
      rowsPageItems: [25, 10, 50, 100, 250],
      deleteDialog: false,
      deleteChecked: false,
      deleteFormValidation: false,
      supplierOrderToDelete: null,
      creatingInvoice: false,
      hideHSCode: false
    }
  },
  methods: {
    visibilityChanged (isVisible, entry) {
      if (this.isVisible !== isVisible) {
        this.isVisible = isVisible
        if (isVisible) {
          console.log('Offers tab visible, load data')
          this.loadItems()
        }
      }
    },
    openDialog (val) {
      if (val !== null) {
        var item = this.getItems.find(x => x.id === val)
        this.$store.dispatch(Picking.actions.setSelectedPicking, item)
        this.$echo.private('messages-chan.' + val).listen('MessageSent', (payload) => {
          console.log('message sent event: ' + JSON.stringify(payload))
          this.$echo.leave('messages-chan.' + val)
          this.loadItems()
        })
      }
      this.$store.dispatch(Picking.actions.openCloseDialog)
    },
    loadItems () {
      const {sortBy, descending, page, rowsPerPage} = this.pagination

      const query = {
        sortBy: sortBy || 'id',
        descending: descending ? 'desc' : 'asc',
        page: page || 1,
        limit: rowsPerPage !== -1 ? rowsPerPage : 0,
        search: this.search ? this.search : '',
        id: this.selectedInvoice.id
      }
      this.$store.dispatch(Picking.actions.loadPickingsForInvoiceId, query)
    },
    throttledLoadItems: _.debounce(function () {
      this.loadItems()
    }, 450),
    onDismissedError () {
      this.$store.dispatch(Settings.actions.clearNetworkError)
      setTimeout(function () {
        location.reload()
      }, 850)
    },
    deletePositionDialog (item) {
      this.positionData = _.cloneDeep(item)
      this.deleteDialog = true
    },
    deletePosition () {
      if (!this.$refs.deleteForm.validate()) {
        return
      }
      this.deleteDialog = false
      this.deleteChecked = false
      this.$store.dispatch(Picking.actions.deletePicking, this.positionData).then(response => {
        if (response !== null) {
          this.loadItems()
        }
      })
    },
    cancelDeleteDialog () {
      this.deleteDialog = false
      this.$refs.deleteForm.reset()
    },
    createInvoice () {
      let invoice = this.selectedInvoice
      invoice.hideHSCode = this.hideHSCode
      this.$store.dispatch(Invoice.actions.createInvoice, invoice).then(response => {
        this.creatingInvoice = true
        this.$echo.private('invoice-created-chan.' + this.selectedInvoice.id).listen('InvoiceCreated', (payload) => {
          console.log('message sent event: ' + JSON.stringify(payload))
          this.$store.dispatch(Invoice.actions.reloadSelectedInvoice, this.selectedInvoice.id).then(response => {
            this.$echo.leave('invoice-created-chan.' + this.selectedInvoice.id)
          })
          this.creatingInvoice = false
        })
      })
    }
  },
  computed: {
    getItems () {
      this.total = this.$store.getters[Picking.getters.pickings].total
      return this.$store.getters[Picking.getters.pickings].data
    },
    selectedInvoice () {
      return this.$store.getters[Invoice.getters.getSelectedInvoice]
    },
    loading () {
      return this.$store.getters[Settings.getters.loading]
    },
    getActiveTab () {
      return 0
    },
    dialogState () {
      return this.$store.getters[Picking.getters.getOpenDialogState]
    },
    getNetworkError () {
      return this.$store.getters[Settings.getters.getNetworkError]
    },
    headers () {
      return [
        {text: 'Picking-ID', value: 'id'},
        {text: 'Colli number', value: 'colli_number'},
        {text: 'Package Type', value: 'packagings_types_id'},
        {text: 'Length (cm)', value: 'length'},
        {text: 'Width (cm)', value: 'width'},
        {text: 'Height (cm)', value: 'height'},
        {text: 'Gross Weight (kg)', value: 'gross_weight'},
        {text: 'Created', value: 'created_at'},
        {text: 'Status', value: 'statusL', sortable: false, align: 'right'},
        {text: 'Actions', value: 'actions', sortable: false, align: 'right'}
      ]
    }
  },
  watch: {
    pagination: {
      handler () {
        this.loadItems()
      },
      deep: true
    },
    search: {
      handler (val) {
        this.throttledLoadItems()
      },
      deep: true
    },
    dialogState: {
      handler (val) {
        if (!val) {
          this.throttledLoadItems()
        }
      },
      deep: true
    }
  }

}
</script>

<style scoped>

    th:focus {
        outline: none !important;
    }

</style>



// WEBPACK FOOTER //
// src/components/Invoices/Pickings/Pickings.vue